import { BackendModel, BackendService } from '../../core/backend.service';
import { CategoriaProducto } from './categoria-producto.model';

export class CategoriaHijo extends BackendModel {

  static path = '/productos/categorias/editar-clasificacion';

  id: number;
  description: string;
  esPrincipal: boolean ;
  categoriaPadre: CategoriaProducto;
  activo:boolean;

  constructor(protected backendService: BackendService, model?: CategoriaHijo) {
    super(backendService, model);
  }
  

  
}



// WEBPACK FOOTER //
// ./src/app/productos/categoria-producto/categoria-hijo.model.ts